import axiosSetup from "../utils/axiosSetup";

export const fetchCustomers = async () => {
  const response = await axiosSetup.get("customers/getAll/customers");
  return response.data.data;
};

export const fetchCustomerNotifications = async (days: number) => {
  const response = await axiosSetup.get(
    `/customers/get-customer-notifications?days=${days}`
  );
  return response.data.data;
};

export const fetchCustomerNotificationCount = async () => {
  const response = await axiosSetup.get(
    `customers/get-customer-notification-count`
  );
  return response.data.data;
};

export const fetchCustomerQuotations = async (customerId: string) => {
  const response = await axiosSetup.post(`/customers/Quotation/`, {
    customerId,
  });
  return response.data.data;
};

export const fetchOneCustomer = async (customerId: string) => {
  const response = await axiosSetup.post("/customers/getOneCustomer", {
    customerId,
  });
  return response.data.data;
};

export const addCustomerQuotation = async (
  customerId: string,
  leadId: string,
  goods: any,
  transportPrice: any
) => {
  const response = await axiosSetup.post("/customers/addCustomerQuotation", {
    id: customerId,
    leadId,
    goods,
    transportPrice: transportPrice,
  });
  return response.data;
};
